



































import Vue from 'vue'
import { mapState } from 'vuex'
import { UserProfileRequest } from '@/types'
import { prepareDataForApi } from '@/utils'
import { app } from '@/firebase'
import ProfileSection from '@/components/Profile/ProfileSection.vue'
import GdprConsent from '@/components/Common/GDPRConsent.vue'

export type VForm = Vue & { validate: () => boolean }
export interface ProfileEditBasicProp {
    valid: boolean
    submitting: boolean
}

export default Vue.extend({
    name: 'MembershipApply',
    components: { ProfileSection, GdprConsent },
    computed: {
        ...mapState('user', ['user']),
        isMobile() {
            return this.$vuetify.breakpoint.mobile
        },
        updatedAtString() {
            const options = { year: 'numeric', month: 'long', day: 'numeric' }
            return this.user.updatedAt && this.user.updatedAt.toLocaleDateString(this.$i18n.locale, options)
        },
    },
    data: (): { profile: UserProfileRequest } & ProfileEditBasicProp => ({
        profile: {
            name: '',
            uemail: '',
            firstNameEng: '',
            lastNameEng: '',
            photoURL: '',
            gender: 'na',
            residence: '',
            emails: [],
            profArea: [],
            thuMajor: [],
            enrollmentTime: null,
            arriveGermanyAt: null,
            publicContactKeys: [],
        },
        valid: false,
        submitting: false,
    }),
    mounted() {
        ;(this.$refs.form as VForm)?.validate()
    },
    methods: {
        setContactPrivacy(key: 'phoneNumber' | 'wechat' | 'github' | 'facebook') {
            if (this.profile.publicContactKeys.includes(key)) {
                this.profile.publicContactKeys = this.profile.publicContactKeys.filter((item) => item !== key)
            } else {
                this.profile.publicContactKeys.push(key)
            }
        },
        onSubmit() {
            if (this.valid) {
                this.valid = false
                this.submitting = true
                app.functions()
                    .httpsCallable('addApplicant')(prepareDataForApi(this.profile))
                    .then(() => {
                        this.submitting = false
                        this.$router.replace(this.$route.path + '#submitted')
                    })
            }
        },
    },
})
